/* unplugin-vue-components disabled */import script from "./International_4.vue?vue&type=script&setup=true&lang=ts"
export * from "./International_4.vue?vue&type=script&setup=true&lang=ts"

import "./International_4.vue?vue&type=style&index=0&id=7c33d24f&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c33d24f"]])

export default __exports__